import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';

import MinimalFooter from '@/components/common/MinimalFooter';
import Footer from '@/components/Layout/Footer';
import Header from '@/components/Layout/Header';
import { useResponsive } from '@/hooks/useResponsive';

const isAuthPath = (pathname: string) => {
  const authPaths = ['/login', '/signup', '/forgot-password'];
  return authPaths.includes(pathname) || pathname.startsWith('/reset-password');
};

export const Route = createFileRoute('/_app')({
  component: AppLayoutRoute,
});

function AppLayoutRoute() {
  const location = useLocation();
  const breakpointIndex = useResponsive([768]);
  const isMobile = breakpointIndex === 0;
  const useMinimalFooter = isAuthPath(location.pathname);
  const isAuthRoute = useMinimalFooter;

  return (
    <div className="flex min-h-svh flex-col">
      <Header />
      <main
        className={
          isAuthRoute
            ? 'flex flex-1 items-center justify-center bg-surface-primary px-4 pt-20'
            : 'flex-1'
        }
      >
        <Outlet />
      </main>
      {useMinimalFooter ? (
        <MinimalFooter variant={isMobile ? 'mobile' : 'desktop'} />
      ) : (
        <Footer />
      )}
    </div>
  );
}
